import { TVideoMode } from '../context/interfaces'

export const VIDEO_MODE_OPTIONS: Array<{ value: TVideoMode; label: string }> = [
  { value: 'animated', label: 'Generate Video' },
  { value: 'storyboard', label: 'Preview storyboard' }
]
